/**
 * End-of-level outro video.
 * Plays public/outro.mp4 fullscreen. When it ends (or skip is pressed)
 * calls onDone() to hand back to the game (show game over / menu).
 */
export class Outro {
  private el: HTMLDivElement;
  private video: HTMLVideoElement;
  private skipBtn: HTMLButtonElement;
  private onDone: () => void = () => {};

  constructor(parent: HTMLElement) {
    this.el = document.createElement("div");
    this.el.className = "intro hidden"; // reuse same fullscreen video styles

    this.video = document.createElement("video");
    this.video.src = "/outro.mp4";
    this.video.playsInline = true;
    this.video.muted = false;
    this.video.preload = "auto";
    this.video.style.cssText =
      "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;";

    this.skipBtn = document.createElement("button");
    this.skipBtn.className = "intro-skip";
    this.skipBtn.textContent = "SKIP";
    this.skipBtn.addEventListener("click", () => this.finish());

    this.video.addEventListener("ended", () => this.finish());

    this.el.appendChild(this.video);
    this.el.appendChild(this.skipBtn);
    parent.appendChild(this.el);
  }

  show(onDone: () => void): void {
    this.onDone = onDone;
    this.el.classList.remove("hidden");
    this.el.style.opacity = "1";
    this.video.currentTime = 0;
    // Try to play with sound. iOS Safari only allows that within the
    // user-gesture window (~5 s) — the arrival cinematic is longer than
    // that, so by the time this runs the gesture has usually expired and
    // play() rejects. Retry muted (always allowed for playsinline video)
    // so the player at least sees the outro. Only fall back to finish()
    // if even muted playback fails.
    this.video.muted = false;
    this.video.play().catch(() => {
      this.video.muted = true;
      this.video.play().catch(() => this.finish());
    });
  }

  private finish(): void {
    this.video.pause();
    this.el.style.transition = "opacity 0.5s";
    this.el.style.opacity = "0";
    window.setTimeout(() => {
      this.el.classList.add("hidden");
      this.onDone();
    }, 520);
  }

  destroy(): void {
    this.video.pause();
    this.el.remove();
  }
}
